module.exports = __webpack_public_path__ + "1545f922.png";